/**
 * vxe-table 按需加载配置
 * 仅注册项目所需的核心组件，避免全量引入影响性能
 *
 * 使用方式：
 *   在模板中直接使用 <vxe-table>、<vxe-column>、<vxe-toolbar> 等组件
 *   如需更多组件（如 VxeGrid、VxeColgroup），在下方按需添加即可
 */
import type { App } from 'vue';

// 核心 UI 配置（语言、主题等）
import { VxeUI } from 'vxe-table/es/ui';

// 按需引入组件
import { VxeTable } from 'vxe-table/es/table';
import { VxeColumn } from 'vxe-table/es/column';
import { VxeColgroup } from 'vxe-table/es/colgroup';
import { VxeToolbar } from 'vxe-table/es/toolbar';

// 按需引入组件样式（仅加载使用组件的 CSS）
import 'vxe-table/es/ui/style.css';
import 'vxe-table/es/table/style.css';
import 'vxe-table/es/column/style.css';
import 'vxe-table/es/colgroup/style.css';
import 'vxe-table/es/toolbar/style.css';

// vxe-pc-ui 组件样式（VxePager 及其依赖子组件）
import 'vxe-pc-ui/es/ui/style.css';
import 'vxe-pc-ui/es/icon/style.css';
import 'vxe-pc-ui/es/button/style.css';
import 'vxe-pc-ui/es/input/style.css';
import 'vxe-pc-ui/es/select/style.css';
import 'vxe-pc-ui/es/option/style.css';
import 'vxe-pc-ui/es/optgroup/style.css';
import 'vxe-pc-ui/es/number-input/style.css';
import 'vxe-pc-ui/es/pager/style.css';

// 中文语言包
import zhCN from 'vxe-table/es/locale/lang/zh-CN';

// 设置默认语言和主题
if (!VxeUI.hasLanguage('zh-CN')) {
  VxeUI.setI18n('zh-CN', zhCN);
}
VxeUI.setLanguage('zh-CN');
VxeUI.setTheme('light');

/**
 * 注册 vxe-table 组件到 Vue 应用
 * 仅注册按需引入的组件，不执行全量 install
 */
export function setupVxeTable(app: App) {
  // 注册核心表格组件
  app.use(VxeTable);
  app.use(VxeColumn);
  app.use(VxeColgroup);
  app.use(VxeToolbar);

  // 将 VxeUI 挂载到全局，便于在组件中通过 getCurrentInstance 访问
  app.config.globalProperties.$vxeUI = VxeUI;
}
